import type Quill from 'quill/core';
import React from 'react';
import { MenuItem } from '../../components/Menu';
import cardIcon from '../../icons/non-prefilled/16x16/card.svg';
import replaceBlotWith from '../utils/replaceBlotWith';
import type { EmbedBlot } from '../types';

interface DisplayAsCardMenuItemProps {
  quill: Quill;
  blot: EmbedBlot;
}

const DisplayAsCardMenuItem = ({ quill, blot }: DisplayAsCardMenuItemProps) => (
  <MenuItem
    icon={cardIcon}
    onClick={() => {
      const { id, type } = blot.statics.value(blot.domNode);
      replaceBlotWith(quill, blot, {
        card: { type, id },
      });
    }}
    testId="displayAsCardMenuItem"
  >
    Display as card
  </MenuItem>
);

export default DisplayAsCardMenuItem;
